import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "react-bootstrap-v5";
import './buttons.scss'

const ButtonClose = ({className, onClick}) => (
    <Button className={`button-close ${className}`} onClick={onClick}><FontAwesomeIcon icon="times"/></Button>
);

export default ButtonClose;